import * as pdfjsLib from 'pdfjs-dist';

pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).href;

let sharedWorker: pdfjsLib.PDFWorker | null = null;

// Without an explicit worker, pdf.js spawns a Web Worker per document.
export const getSharedPdfWorker = (): pdfjsLib.PDFWorker => {
  if (!sharedWorker || sharedWorker.destroyed) {
    sharedWorker = new pdfjsLib.PDFWorker();
  }
  return sharedWorker;
};

export { pdfjsLib };
